import {isEmptyString} from "utils/text";
import {tenantTimeFormat} from "utils/time";
import moment from "moment";

const tenantCustomTimeFormat = (time) => moment(time, "HH:mm").format(tenantTimeFormat("time"))

// If an object is an instance of moment, format it using the tenant's custom format.
// If not, assume the format is correct already.
const convertMomentToDateString = (momentObject) =>
    momentObject instanceof moment ? momentObject?.format(tenantTimeFormat("date")) : momentObject;

export const formattedDateTime = (timing, dateType) => {
    if (timing === null || timing[`${dateType}Date`] === null || timing[`${dateType}Time`] === null ) return null
    return convertMomentToDateString(timing[`${dateType}Date`]) + ' ' + tenantCustomTimeFormat(timing[`${dateType}Time`])
}

export function formValidationErrorState(formData) {
    return {
        title: {
            value: formData.title, error: isEmptyString(formData.title) ? "Must provide a title" : ""
        },
        build: {
            error: !formData.elements.some(item => item.elementType === 'QUESTION') ? 'Must add at least 1 question' : ""
        },
        audience: {
            error: !formData.audience || (!formData.audience.allStudents && !formData.audience.cohortIds)
                ? 'Must select All Students or specify at least 1 cohort' : ''
        },
        openDateTime: {
            value: formattedDateTime(formData.timing, "open"),
            error: !formData.timing.openDate ? 'Must select an Open Date and Open Time' : ''
        }
    }
}

export function formHasError(formData) {
    return Object.values(formValidationErrorState(formData)).some(item => Boolean(item.error))
}
